import {
  FormsHandbook as Data,
  FormsHandbookCollection as Collection,
} from '@/typings/api/FormsHandbook'
import {
  BaseApiResponse as BR,
} from '@/typings/common'

import { BaseApiAuth } from '@/api/BaseApiAuth'
import { AxiosRequestConfig } from 'axios'


export class FormsHandbookApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'data-collection/forms-handbook';

  public detail(id: number, config: AxiosRequestConfig = {}) {
    const path = `${id}/`
    const [url] = this.getUrl(path)

    return this.request<never, BR<Data>>('GET', url, { ...config })
  }

  public list(config: AxiosRequestConfig = {}) {
    const path = 'all/'
    const [url] = this.getUrl(path)

    return this.request<never, BR<Data[]>>('GET', url, { ...config })
  }
}
